import type { ValidatedApiClient } from '../types/api-client';
import { getMontageResponseSchema, getMontagesResponseSchema } from './schema';

export const createMontagesApi = ({ validatedFetch }: ValidatedApiClient) => ({
    getAll: () => validatedFetch(getMontagesResponseSchema, '/v3/montages'),
    getById: (id: string) => validatedFetch(getMontageResponseSchema, `/v3/montages/${encodeURIComponent(id)}`),
});
